// copied from Willy

import React from "react";
import PropTypes from "prop-types";

import Style from "./line.module.css";

export default function LineTable({ children }) {
	return (
		<table className={Style["line-table"]}>
			<tbody>{children}</tbody>
		</table>
	);
}

LineTable.propTypes = {
	children: PropTypes.node
};

LineTable.defaultProps = {
	children: <></>
};
